// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReviewBidPackageIncomingUpdatesMutationVariables = Types.Exact<{
  input: Types.ReviewBidPackageIncomingUpdatesInput;
}>;


export type ReviewBidPackageIncomingUpdatesMutation = { __typename?: 'Mutation', reviewBidPackageIncomingUpdates: { __typename?: 'BidPackage', id: string } };

export type ReviewScopeChangesCard_IncomingUpdateFragment = { __typename?: 'BidPackageIncomingUpdate', id: string, source: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } };

export const ReviewScopeChangesCard_IncomingUpdateFragmentDoc = gql`
    fragment ReviewScopeChangesCard_IncomingUpdate on BidPackageIncomingUpdate {
  id
  source {
    id
    version
  }
}
    `;
export const ReviewBidPackageIncomingUpdatesDocument = gql`
    mutation ReviewBidPackageIncomingUpdates($input: ReviewBidPackageIncomingUpdatesInput!) {
  reviewBidPackageIncomingUpdates(input: $input) {
    id
  }
}
    `;
export type ReviewBidPackageIncomingUpdatesMutationFn = Apollo.MutationFunction<ReviewBidPackageIncomingUpdatesMutation, ReviewBidPackageIncomingUpdatesMutationVariables>;

/**
 * __useReviewBidPackageIncomingUpdatesMutation__
 *
 * To run a mutation, you first call `useReviewBidPackageIncomingUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewBidPackageIncomingUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewBidPackageIncomingUpdatesMutation, { data, loading, error }] = useReviewBidPackageIncomingUpdatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewBidPackageIncomingUpdatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReviewBidPackageIncomingUpdatesMutation, ReviewBidPackageIncomingUpdatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReviewBidPackageIncomingUpdatesMutation, ReviewBidPackageIncomingUpdatesMutationVariables>(ReviewBidPackageIncomingUpdatesDocument, options);
      }
export type ReviewBidPackageIncomingUpdatesMutationHookResult = ReturnType<typeof useReviewBidPackageIncomingUpdatesMutation>;
export type ReviewBidPackageIncomingUpdatesMutationResult = Apollo.MutationResult<ReviewBidPackageIncomingUpdatesMutation>;
export type ReviewBidPackageIncomingUpdatesMutationOptions = Apollo.BaseMutationOptions<ReviewBidPackageIncomingUpdatesMutation, ReviewBidPackageIncomingUpdatesMutationVariables>;